import { render } from "./AnnouncePost.vue?vue&type=template&id=3a34cd40&scoped=true"
import script from "./AnnouncePost.vue?vue&type=script&lang=js"
export * from "./AnnouncePost.vue?vue&type=script&lang=js"

import "./AnnouncePost.vue?vue&type=style&index=0&id=3a34cd40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a34cd40"]])

export default __exports__